/* eslint-disable import/no-named-as-default */
import React from 'react';
import { Button } from '@sendgrid/ui-components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PersonalInfo from './PersonalInfo';
import withProfileInputs from '../containers/withProfileInputs';
import BetaBadge from './BetaBadge';
import Styles from './adsProfileForm.module.scss';

export class ProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.isFormDisabled = true;
    this.onSave = this.onSave.bind(this);
  }

  componentWillMount() {
    this.props.fetchStatus();
  }

  componentDidMount() {
    this.props.setAdsUser(true);
    // Pulled ehawk out of react into index.html where it
    //  is invoked and updates the talon id value. When
    //  using react we were not able to get the updated
    //  input.talon value without a race condition.
    //  https://www.e-hawk.net/support/api.php 12/20/2017
    const talon = document.getElementById('talon');
    this.props.setEhawkTalon(talon);
  }

  componentWillUpdate(nextProps) {
    this.isFormDisabled = !(nextProps.profileInputs.isValidForm);
  }

  onSave() {
    if (!this.isFormDisabled) {
      this.props.onSave(this.props.profileInputs, this.props.history);
    }
  }

  render() {
    return (
      <div>
        <div className={Styles.formInfo}>
          <h4>SENDGRID ADS <BetaBadge /></h4>
          <h1>Tell Us About Yourself</h1>
          <h3>This information will help us serve you better.</h3>
        </div>
        <div className="provision" data-role="profile-container">
          <PersonalInfo />
          <center>
            <Button
              type="primary"
              onClick={this.onSave}
              data-role="save-button"
              disabled={this.isFormDisabled}
            >Get Started!
            </Button>
          </center>
        </div>
      </div>
    );
  }
}

ProfileForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  setAdsUser: PropTypes.func.isRequired,
  setEhawkTalon: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    isValidForm: PropTypes.bool.isRequired,
  }).isRequired,
  fetchStatus: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(withProfileInputs(ProfileForm));



// WEBPACK FOOTER //
// ./src/components/AdsProfileForm.jsx